import { arrayOf, exact, number, string } from 'prop-types';

export const TagType = exact({
  id: string.isRequired,
  items: arrayOf(string).isRequired,
  label: string.isRequired,
  order: number.isRequired,
});

export const TagsType = arrayOf(TagType);
